<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div v-if="typeof content !== 'object'">
					<div v-if="i === 'content'" class="form-group">
						<label>{{ i }}</label>	
						<textarea rows="5" class="form-control" :id="`${i}client-box${index}`" v-model="componentItem.content[i]"></textarea>
					</div>
					<span v-else-if="i === 'logo'">
						<OptionalObjectField 
							:componentItemContent="componentItem.content" 
							:componentItemKey="'logo'" 
							:componentItemSampleContent="sampleContent['logo']"
							:forTemplate="componentItem.template" 
						>
						</OptionalObjectField>
					</span>
					<div v-else class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
				<div v-else-if="i === 'find-out-more'">
					<div v-for="(item, i) in content" v-bind:key="i">
						<div v-bind:key="i">
							<div class="form-group">
								<label>{{ i }}</label>
								<input v-if="i !== 'description'" type="text" class="form-control" :id="i" v-model="content[i]" >
								<textarea v-else rows="15" class="form-control" :id="`${i}image-and-body-copy${index}`" v-model="content[i]"></textarea>
							</div>
						</div> 
					</div>
				</div>
				<div v-else-if="i === 'background-image'">
					<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import OptionalObjectField from '../OptionalObjectField.vue';

	export default {

		components: {
			BackgroundImage,
			OptionalObjectField
		},		
		
		name: 'ClientBox',
		
		props: ['componentItem', 'index', 'sampleContent'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>